import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AdminAppointmentsComponent } from './routes/admin/admin-appointments/admin-appointments.component';
import { NotFoundComponent } from './routes/not-found/not-found.component';
import { TestComponent } from './components/test/test.component';
import { AppComponent } from './app.component';
import { PlanningComponent } from './routes/common/planning/planning.component';
import { tabDirtyGuard } from './libs/components/tabs-host/tab-dirty.guard';
import { CommonComponent } from './routes/common/common.component';

// Add canDeactivateChild guard
// https://github.com/angular/angular/issues/11836

import { default as config } from '../../config.json';
import { access, saveAppUri } from './libs/guards';
import { ProductionTimeScheduleComponent } from './libs/components/production-time-schedule/production-time-schedule.component';
import { TimersListComponent } from './routes/oms/components/timers-list/timers-list.component';
import { WorkersPlannerComponent } from './routes/aps/components/workers-planner/workers-planner.component';
import { PlannerComponent } from './routes/common/planner/planner.component';
import { ClockingInTerminalComponent } from './routes/hr/hr-operative/hr-attendance-entries/components/clocking-in-terminal/clocking-in-terminal.component';
import {AdminAlertsComponent} from "./routes/admin/admin-alerts/admin-alerts.component";
import {AdminHomesComponent} from "./routes/admin/admin-homes/admin-homes.component";

const defaultPath = '/' + config.items.modules.find(x => x.visible)!.id;

const routes: Routes = [
  { path: '', redirectTo: defaultPath, pathMatch: 'full' },
  { path: 'ResetPassword', component: AppComponent },
  { path: 'foobarbazz', component: TestComponent },
  { path: 'admin', loadChildren: () => import('./routes/admin/admin.module').then(m => m.AdminModule)},
  { path: 'user', loadChildren: () => import('./routes/user/user.module').then(m => m.UserModule)},
  { path: 'common', component: CommonComponent, data: { breadcrumb: 'common' }, children: [
    { path: 'appointments', component: AdminAppointmentsComponent, data: { breadcrumb: 'appointments' }, canActivate: [access], canDeactivate: [tabDirtyGuard]  },
    { path: 'homes', component: AdminHomesComponent, data: { breadcrumb: 'homes' }, canActivate: [access], canDeactivate: [tabDirtyGuard]  },
    { path: 'planning-old', component: PlanningComponent , data: { breadcrumb: 'operationPlanning' }, canActivate: [access], canDeactivate: [tabDirtyGuard]  },
    { path: 'planning', component: PlannerComponent , data: { breadcrumb: 'operationPlanning' }, canActivate: [access], canDeactivate: [tabDirtyGuard]  },
    { path: 'workers-planning', component: WorkersPlannerComponent , data: { breadcrumb: 'workersPlanning' }, canActivate: [access], canDeactivate: [tabDirtyGuard]  },
    { path: 'calendar', component: ProductionTimeScheduleComponent , data: { breadcrumb: 'calendar' }, canActivate: [access], canDeactivate: [tabDirtyGuard]  },
    { path: 'timers', component: TimersListComponent , data: { breadcrumb: 'timers' }, canActivate: [access], canDeactivate: [tabDirtyGuard]  },
    { path: 'clocking-terminal', component: ClockingInTerminalComponent , data: { breadcrumb: 'clockingTerminal' }, canActivate: [access], canDeactivate: [tabDirtyGuard]  },
  ]},
  { path: 'dir', loadChildren: () => import('./routes/directory/dir.module').then(m => m.DirModule)},
  { path: 'hr', loadChildren: () => import('./routes/hr/hr.module').then(m => m.HrModule)},
  { path: 'ams', loadChildren: () => import('./routes/assets/assets.module').then(m => m.AssetsModule)},
  { path: 'products', loadChildren: () => import('./routes/products/products.module').then(m => m.ProductsModule)},
  { path: 'wms', loadChildren: () => import('./routes/wms/wms.module').then(m => m.WmsModule)},
  { path: 'pms', loadChildren: () => import('./routes/pms/pms.module').then(m => m.PmsModule)},
  { path: 'oms', loadChildren: () => import('./routes/oms/oms.module').then(m => m.OmsModule)},
  { path: 'aps', loadChildren: () => import('./routes/aps/aps.module').then(m => m.ApsModule)},
  { path: 'mes', loadChildren: () => import('./routes/mes/mes.module').then(m => m.MesModule)},
  { path: 'fms', loadChildren: () => import('./routes/fms/fms.module').then(m => m.FmsModule)},
  { path: 'tms', loadChildren: () => import('./routes/tms/tms.module').then(m => m.TmsModule)},
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
